import { render, staticRenderFns } from "./CertificateItem.vue?vue&type=template&id=002f4c71&scoped=true&"
import script from "./CertificateItem.vue?vue&type=script&lang=js&"
export * from "./CertificateItem.vue?vue&type=script&lang=js&"
import style0 from "./CertificateItem.vue?vue&type=style&index=0&id=002f4c71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002f4c71",
  null
  
)

export default component.exports